import React from "react";
import { Navigate } from "react-router-dom";

const AcceptInvitationView: React.FC = () => {
    // Legacy to support links in old mails
    return <Navigate to="/login?redirect=/representatives&tab=REQUESTS" />;
};

export default AcceptInvitationView;